var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getLocalStorage, LS_AUTHID, LS_AUTHTYPE, clearAuthStorage } from "@/utils/storage";
import { checkType, logout } from "@/api/auth";
import { ROUTE_LOGIN } from "@/utils/context/constants";
export const SUPERADMIN = 8;
export const ADMIN = 4;
export const VIEWER = 2;
export const isAdminFromLS = () => {
    const userType = getLocalStorage(LS_AUTHTYPE);
    return ((userType !== null && Number(userType) === SUPERADMIN) ||
        (userType !== null && Number(userType) === ADMIN));
};
export const isSuperAdminFromLS = () => {
    const userType = getLocalStorage(LS_AUTHTYPE);
    return ((userType !== null && Number(userType) === SUPERADMIN));
};
export const isSuperAdmin = check => {
    const userType = getLocalStorage(LS_AUTHTYPE);
    const userId = getLocalStorage(LS_AUTHID);
    return userType !== null && (check.authid === userId &&
        check.type === +userType &&
        !!userType &&
        SUPERADMIN === +userType);
};
export const isAdmin = check => {
    const userType = getLocalStorage(LS_AUTHTYPE);
    const userId = getLocalStorage(LS_AUTHID);
    return userType !== null && (check.authid === userId &&
        check.type === +userType &&
        !!userType &&
        ADMIN === +userType);
};
export const isViewer = check => {
    const userType = getLocalStorage(LS_AUTHTYPE);
    const userId = getLocalStorage(LS_AUTHID);
    return userType !== null && (check.authid === userId &&
        check.type === +userType &&
        !!userType &&
        VIEWER === +userType);
};
export const checkAuth = (check) => __awaiter(void 0, void 0, void 0, function* () {
    const asyncCheck = yield checkType();
    if (asyncCheck && asyncCheck.status === 'expired') {
        throw new Error('session_expired');
    }
    //console.log('----> to check:', check);
    if (check === SUPERADMIN) {
        return isSuperAdmin(asyncCheck);
    }
    if (check === ADMIN) {
        return isSuperAdmin(asyncCheck) || isAdmin(asyncCheck);
    }
    if (check === VIEWER) {
        return (isSuperAdmin(asyncCheck) || isAdmin(asyncCheck) || isViewer(asyncCheck));
    }
    return true;
});
export const logoutProcedure = (navigate = null, config = undefined) => {
    logout().then((data) => {
        if (!!data && !!(data === null || data === void 0 ? void 0 : data.status) && (data === null || data === void 0 ? void 0 : data.status) === 'success') {
            clearAuthStorage();
            !!navigate && navigate(ROUTE_LOGIN);
        }
        else {
            // Se il logout fallisce (es. token già invalido), puliamo comunque lo storage locale
            clearAuthStorage();
            !!navigate && navigate(ROUTE_LOGIN);
            console.warn((config === null || config === void 0 ? void 0 : config.strLogoutError) || "Logout failed, but local storage cleared.");
        }
    }).catch(() => {
        // In caso di errore di rete o 401 gestito da handleResponse (reject)
        clearAuthStorage();
        !!navigate && navigate(ROUTE_LOGIN);
    });
};
export const logoutWithoutApi = (navigate = null) => {
    clearAuthStorage();
    !!navigate && navigate(ROUTE_LOGIN);
};
